import React, {useState} from 'react';
import Markdown from '../../../Markdown';
import {DisclaimerModal} from '../../../Modals';
import './index.scss';

/**
 * Component to render highlight row cell with disclaimer text
 */
export const HighlightRowCell = ({settings, styleSheet, value, rowData}) => {
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  const handleDisclaimerClick = (e) => {
    e.preventDefault();
    setShowDisclaimerModal(true);
  };

  const handleHide = () => {
    setShowDisclaimerModal(false);
  };

  return (
    <>
      <div className="highlight-row">
        <p>{value}</p>
        {settings?.table?.highlightRow?.disclaimerText && (
          <div className="highlight-row-para">
            <a className="highlight-row-disclaimer" onClick={handleDisclaimerClick}>
              <Markdown>{settings.table.highlightRow.disclaimerText}</Markdown>
            </a>
          </div>
        )}
      </div>
      <DisclaimerModal
        settings={settings}
        styleSheet={styleSheet}
        showDisclaimerModal={showDisclaimerModal}
        handleHide={handleHide}
      />
    </>
  );
};

